<template>
<div class="fullWidth fCol aCenter jStart">
  <div class='pRow fRow jBetween aCenter fullWidth'>
    <div class='tableHead title fCol jStart aCenter'>
      <div class="fullWidth accessTitle title">{{data.title}}</div>
      <div :title="data.description" class="fullWidth accessTitle desc">{{shortDesc}}</div>
    </div>
    <div class='tableHead state aCenter jCenter fCol'>
      <div v-if="false" v-bind:class="{off: !isActive, wait: whileState}" class="switch"
      @mouseover='disableExpand'
      @click="invertState"
      @mouseleave="enableExpand">
      <div class="l"></div>
        <div class="switchLabel" v-bind:class="{info: isActive, error: !isActive}">
          {{perState}}
        </div>
      </div>
      <switch-button
        activeLabel='فعال'
        deactiveLabel='غیرفعال'
        @click.native="setState"
        :load='whileState'
        @mouseover.native='disableExpand'
        @mouseleave.native="enableExpand"
        :val='accessState' />
    </div>
    <div class='tableHead actions'>
      <i @mouseover='disableExpand'
        @click="showPermissions"
        @mouseleave="enableExpand" class='material-icons-round'>format_list_numbered_rtl</i>
      <i @mouseover='disableExpand'
        @click="goEdit"
        @mouseleave="enableExpand"
        class='material-icons-round'>edit</i>
      <i @mouseover='disableExpand'
        @click="deleteAccess"
        @mouseleave="enableExpand" class='material-icons-round'>clear</i>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import SwitchButton from '@/components/SwitchButton.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import { EventBus } from '@/plugins/event-bus';
// import makeT from '@/mixins/mixin';
// mixins: [errorHandler],
// this.makeToast('error', this.errorHandler(error), 2000);
export default {
  mixins: [errorHandler, makeToast],
  data() {
    return {
      expanded: false,
      expndHeight: 0,
      isActive: false,
      whileState: false,
      accessState: false,
      accessId: this.data.id,
      accessName: '',
      perMethod: '',
      perLocPath: '',
      perServerPath: '',
      perIcon: '',
      perTitle: '',
      perId: '',
      perState: '',
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
    };
  },
  props: ['data'],
  methods: {
    showPermissions() {
      this.$emit('details');
    },
    expandRow() {
      // alert('hiii');
    },
    disableExpand() {
      this.$store.commit('disExpand');
      // console.log(this.$store.state.letExpand);
    },
    enableExpand() {
      this.$store.commit('enExpand');
      // console.log(this.$store.state.letExpand);
    },
    editPermision() {
      // new
      console.log('event bus from ', this.accessId);
      // alert(`edit premision id = ${this.perId}`);
      this.$store.commit('setWorkOn', 'access');
      this.$store.commit('openCard', this.accessId);
      this.$store.commit('setEditMode');
      setTimeout(() => {
        EventBus.$emit('init', {
          id: this.accessId,
          title: this.data.title,
          desc: this.data.description,
          status: this.data.status,
        });
      }, 1000);
    },
    deleteAccess() {
      // alert(`delete premision id = ${this.accessId}`);
      this.$store.commit('setWorkOn', 'access');
      this.$store.commit('setDeleteMode', this.data.title);
      this.$store.commit('openCard', this.accessId);
    },
    invertState() {
      // alert(`change premision state = ${this.pState}, change it to somthing`);
      let tempState = this.data.status;
      this.whileState = true;
      this.perState = '○';
      let aaa = this.accessState;
      if (this.accessState) {
        tempState = 2;
      } else {
        tempState = 1;
      }
      // console.log('aaa: ', aaa);
      axios({
        method: 'put',
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        url: `${this.baseURL}/api/v${this.V}/Accesses/${this.accessId}`,
        data: {
          title: this.data.title,
          description: this.data.description,
          status: tempState,
          // permissionsId: this.aPermissions,
        },
      }).then((response) => {
        // console.log('active/deactive access', response);
        if (response.data.isSuccess) {
          this.whileState = false;
          this.accessState = !this.accessState;
          aaa = !aaa;
          if (aaa) {
            this.makeToast('success', 'دسترسی مورد نظر فعال شد', 2000);
          } else {
            this.makeToast('success', 'دسترسی مورد نظر غیرفعال شد', 2000);
          }
        }
      }, (error) => {
        // console.log(error);
        this.makeToast('error', this.errorHandler(error), 2000);
      });
    },
    setState() {
      axios({
        method: 'patch',
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        url: `${this.baseURL}/api/v${this.V}/Accesses/${this.accessId}?status=${!this.accessState}`,
      }).then((response) => {
        // console.log('active/deactive access', response);
        if (response.data.isSuccess) {
          this.whileState = false;
          this.accessState = !this.accessState;
          if (this.accessState) {
            this.makeToast('success', 'دسترسی مورد نظر فعال شد', 2000);
          } else {
            this.makeToast('success', 'دسترسی مورد نظر غیرفعال شد', 2000);
          }
        }
      }, (error) => {
        // console.log(error);
        this.makeToast('error', this.errorHandler(error), 2000);
      });
    },
    init() {
      // this.permissions = this.aPermissions;
      this.accessId = this.data.id;
      this.accessName = this.data.title;
      // console.log(this.accessId, this.accessName);
      // console.log(this.permissions);
      this.accessState = this.data.status;
    },
    goEdit() {
      this.$emit('edit', this.data);
    },
  },
  components: {
    SwitchButton,
  },
  computed: {
    shortDesc() {
      let cdstr = this.data.description;
      try {
        // console.log('cdstr', cdstr);
        if (cdstr.length > 55) {
          cdstr = `${cdstr.substr(0, 54)}...`;
        }
      } catch (error) {
        // console.log(error);
      }
      return cdstr;
    },
    changeAccessStatus() {
      let acState = false;
      // console.log('accessState', this.accessState);
      if (this.accessState === 1) {
        acState = true;
      } else {
        acState = false;
      }
      // console.log('hooooy', acState);
      return acState;
    },
  },
  watch: {
  },
  mounted() {
    this.$nextTick(() => {
      console.log(this.permissions);
      this.init();
    });
    // if (this.pState === 1) {
    //   this.perState = 'فعال';
    //   this.isActive = true;
    // } else {
    //   this.perState = 'غیرفعال';
    //   this.isActive = false;
    // }
  },
};
</script>

<style lang='scss' scoped>
.pRow {
  height: 88px;
  min-height: 88px;
  transition: all cubic-bezier(0.5,0,0,1) 0.5s;
}

.fullHeight{
  height: 100%;
}

.pRow:hover {
  background-color: rgba($color: #000000, $alpha: 0.02);
}

.wait {
  opacity: 0.3;
  filter: grayscale(100%);
}

.accessTitle{
  padding: 0 32px 0 8px;
  text-align: right;
}

.title{
  font-size: 14px;
}

.desc{
  font-size: 10px;
}
.actions {
  width: 134px;
  i {
    font-size: 16px;
  }
}
</style>
